import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import {
  OVERLAY_THEME2_STYLES_URL,
  fetchOverlayTheme2CssText,
  applyOverlayTheme2VarsToRoot,
} from "./overlayTheme2Utils";

const DESIGN_IMG = "https://superplayerauction.com/manage/images/design.png";
const HAMMER_IMG = "https://superplayerauction.com/manage/images/hammer.png";
const UNSOLD_IMG =
  "https://superplayerauction.com/manage/images/UNSOLDstamp.png";
const PLAYER_IMG =
  "https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/1773822625769-348960600.png";
const TEAM_LOGO =
  "https://mscsuper.blr1.digitaloceanspaces.com/teams/1780566779102-120289297.jpg";

function TeamRow({ name, points, players, isScroll = false }) {
  return (
    <div className="item1 tm_grp_all" style={{ display: "flex" }}>
      <div className={`teamitem${isScroll ? " is-scroll" : ""}`}>
        <div className="teamitem-clip">
          <span className="teamitem-scroll">{name}</span>
        </div>
      </div>
      <div className="t-point">
        {points}
        <span className="pointtyp"> </span>
      </div>
      <div className="t-player">{players}</div>
    </div>
  );
}

function OverlayTheme2Content({ previewMode = "currentPlayer" }) {
  const isSold = previewMode === "sold";
  const isUnsold = previewMode === "unsold";
  const showBidding = !isSold && !isUnsold;

  return (
    <div className="overlay-1" data-ov-theme2-root="true">
      <div
        className="content-1"
        style={{ display: "flex", transform: "translateX(-170px)" }}
      >
        <div className="top-img">
          <div id="pic" className="player-image">
            <img src={PLAYER_IMG} width="120" height="120" alt="Player" />
          </div>
        </div>
        <div
          className={`top-relative${showBidding ? "" : " is-outcome"}`}
        >
          <div
            className="bbid"
            style={{ display: showBidding ? "flex" : "none" }}
          >
            <div className="base-bid">
              <div className="base-label">Base Price</div>
              <div id="basebid" className="base-value">
                0.10
              </div>
            </div>
          </div>
          <div
            className="player"
            style={{ display: showBidding ? "flex" : "none" }}
          >
            <div className="player-name">
              <img src={DESIGN_IMG} alt="" />
              <img src={DESIGN_IMG} alt="" />
              <img src={DESIGN_IMG} alt="" />
              <img src={DESIGN_IMG} alt="" />
              <img src={DESIGN_IMG} alt="" />
              <span id="playername">Bhawani Singh</span>
            </div>
          </div>
          <div
            className="currentbid"
            style={{ display: showBidding ? "flex" : "none" }}
          >
            <div id="teamname" className="currentteam">
              COLLINS COMETS
            </div>
            <div className="current-bid">
              <div className="current-bid-label">Current Bid</div>
              <div id="currentbid" className="current-bid-value">
                0.10 <span className="pointtyp"> </span>
              </div>
            </div>
          </div>
          <div
            className="sold-d"
            style={{ display: isSold ? "block" : "none" }}
          >
            <div className="sold-detail">
              <div id="soldteamlogo">
                <img src={TEAM_LOGO} alt="" />
              </div>
              <div className="sold-to">
                <span id="soldplname" className="sold-p-name">
                  Bhawani Singh
                </span>
                <span id="soldteam" className="sold-t-name">
                  COLLINS COMETS
                </span>
              </div>
              <div id="soldbid" className="sold-point">
                23.75 Cr
              </div>
            </div>
          </div>
          <div
            className="unsold-d"
            style={{ display: isUnsold ? "block" : "none" }}
          >
            <div className="unsold-detail">
              <div className="unsold-to">
                <span id="unsoldplayername" className="unsold-p-name">
                  Bhawani Singh
                </span>
              </div>
              <div className="unsold-label">
                <img src={UNSOLD_IMG} alt="" />
              </div>
            </div>
            <div className="unsold-detail-outer" />
          </div>
        </div>
        <div className="player-bottom" style={{ display: "flex" }}>
          <div className="player-detail">
            <div id="spcf1" className="spec" style={{ fontSize: "12px" }}>
              Left-Handed opening Batsman
            </div>
            <div id="spcf2" className="spec2" style={{ fontSize: "12px" }}>
              Left-Arm orthodox spinner
            </div>
            <div id="cat-age" className="age">
              Age 23
            </div>
          </div>
        </div>
        <div className="hamm">
          <img
            className="hammer"
            src={HAMMER_IMG}
            alt=""
            style={{ display: "none", transform: "none" }}
          />
        </div>
      </div>

      <div className="content-2" style={{ display: "flex" }}>
        <div className="header-main" style={{ transform: "translateY(0px)" }}>
          <div className="header">
            <div className="teamitem-h">Teams</div>
            <div className="t-point-h">Balance</div>
            <div className="t-player-h">Player</div>
          </div>
        </div>

        <div
          className="header-items is-open"
          style={{ display: "flex", top: "2px" }}
        >
          <TeamRow name="COLLINS COMETS" points="10" players="0" />
          <TeamRow
            name="COLOSSEUM SUPER KINGS"
            points="10"
            players="0"
            isScroll
          />
          <TeamRow
            name="CURRASSO CONQUERORS"
            points="10"
            players="0"
            isScroll
          />
          <TeamRow
            name="GLITORIUM GLADIATORS"
            points="10"
            players="0"
            isScroll
          />
          <TeamRow name="ICA INVINCIBLES" points="10" players="0" />
          <TeamRow name="KEUS STRIKERS" points="10" players="0" />
        </div>
      </div>
    </div>
  );
}

function getTheme2Root(mount) {
  return mount?.querySelector("[data-ov-theme2-root]") || null;
}

export default function OverlayTheme2Preview({
  themeVars = {},
  clearedCssVars = new Set(),
  previewMode = "currentPlayer",
}) {
  const hostRef = useRef(null);
  const mountRef = useRef(null);
  const themeVarsRef = useRef(themeVars);
  const clearedCssVarsRef = useRef(clearedCssVars);
  const previewModeRef = useRef(previewMode);

  themeVarsRef.current = themeVars;
  clearedCssVarsRef.current = clearedCssVars;
  previewModeRef.current = previewMode;

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    const shadowRoot =
      host.shadowRoot ??
      host.attachShadow({
        mode: "open",
      });

    if (mountRef.current) return;

    let cancelled = false;

    const mountPreview = () => {
      if (cancelled || mountRef.current) return;

      const mountPoint = document.createElement("div");
      mountPoint.classList.add("cuspre", "body");
      // mountPoint.style.cssText = "width:100%;height:100%;position:relative;";
      shadowRoot.appendChild(mountPoint);
      mountRef.current = mountPoint;

      ReactDOM.render(
        <OverlayTheme2Content previewMode={previewModeRef.current} />,
        mountPoint,
      );

      applyOverlayTheme2VarsToRoot(
        getTheme2Root(mountPoint),
        themeVarsRef.current,
        clearedCssVarsRef.current,
      );
    };

    const mountWithLink = () => {
      if (shadowRoot.querySelector('link[data-ov-style9="true"]')) {
        mountPreview();
        return;
      }
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = OVERLAY_THEME2_STYLES_URL;
      link.dataset.ovStyle9 = "true";
      link.addEventListener("load", mountPreview);
      link.addEventListener("error", () => {
        console.error("Failed to load overlay theme 2 stylesheet");
        mountPreview();
      });
      shadowRoot.appendChild(link);
      if (link.sheet) mountPreview();
    };

    if (!shadowRoot.querySelector("#ov-theme2-styles")) {
      fetchOverlayTheme2CssText()
        .then((cssText) => {
          if (cancelled || mountRef.current) return;

          const previewFix = document.createElement("style");
          previewFix.id = "ov-theme2-preview-fix";
          previewFix.textContent = `
            :host {
              display: block;
              width: 100%;
              height: 100%;
              position: relative;
              overflow: hidden;
              background: transparent;
            }
            .overlay-1 {
              height: 100%;
              min-height: 520px;
              position: relative;
            }
          `;
          shadowRoot.appendChild(previewFix);

          const styleEl = document.createElement("style");
          styleEl.id = "ov-theme2-styles";
          styleEl.textContent = cssText;
          shadowRoot.appendChild(styleEl);

          mountPreview();
        })
        .catch((error) => {
          console.error(
            "Failed to fetch overlay theme 2 stylesheet, falling back to link",
            error,
          );
          if (!cancelled) mountWithLink();
        });
    } else {
      mountPreview();
    }

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    ReactDOM.render(
      <OverlayTheme2Content previewMode={previewMode} />,
      mount,
    );

    applyOverlayTheme2VarsToRoot(
      getTheme2Root(mount),
      themeVarsRef.current,
      clearedCssVarsRef.current,
    );
  }, [previewMode]);

  // Same pipeline as PublicViewPreview — themeVars + clearedCssVars on root
  useEffect(() => {
    applyOverlayTheme2VarsToRoot(
      getTheme2Root(mountRef.current),
      themeVars,
      clearedCssVars,
    );
  }, [themeVars, clearedCssVars]);

  return (
    <div
      className="ov-theme2-preview-host"
      ref={hostRef}
      // style={{ width: "100%", height: "100%", minHeight: 520 }}
    />
  );
}
